import { useState } from 'react';

type ViewFormat = 'kanban' | 'list';

interface UserConfig {
  'credit-request': {
    'view-format': ViewFormat;
    'kanban-last-phase': string;
    'kanban-last-team': string;
  };
  app: {
    language: string;
  };
}

const STORAGE_KEY = 'user-config';

const defaultConfig: UserConfig = {
  'credit-request': {
    'view-format': 'list',
    'kanban-last-phase': '',
    'kanban-last-team': '',
  },
  app: {
    language: 'pt-br',
  },
};

const getUserConfig = (): UserConfig => {
  const storedConfig = localStorage.getItem(STORAGE_KEY);
  return storedConfig ? JSON.parse(storedConfig) : defaultConfig;
};

const saveUserConfig = (config: UserConfig) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
};

export const useUserCachedConfig = () => {
  const [config, setConfigState] = useState<UserConfig>(getUserConfig());

  const setConfig = <T extends keyof UserConfig>(
    feature: T,
    key: keyof UserConfig[T],
    value: UserConfig[T][keyof UserConfig[T]],
  ) => {
    const newConfig = {
      ...config,
      [feature]: {
        ...config[feature],
        [key]: value,
      },
    };
    saveUserConfig(newConfig);
    setConfigState(newConfig);
  };

  return {
    config,
    setConfig,
  };
};
